/**
 * My Cars Action Types
 */
export const SET_MY_CARS = 'SET_MY_CARS';
export const SET_CURRENT_VEHICLE = 'SET_CURRENT_VEHICLE';
export const SET_MY_CARS_REQUEST_COMPLETE = 'SET_MY_CARS_REQUEST_COMPLETE';
export const SET_LOAN_AND_BANK_DETAILS = 'SET_LOAN_AND_BANK_DETAILS';
export const SET_LOAN_DETAILS = 'SET_LOAN_DETAILS';
export const SET_BANK_DETAILS = 'SET_BANK_DETAILS';
export const SET_LOAN_DETAILS_INPROGRESS = 'SET_LOAN_DETAILS_INPROGRESS';
export const SET_VEHICLE_DETAILS_COMPLETE = 'SET_VEHICLE_DETAILS_COMPLETE';
export const SET_LOAN_DETAILS_COMPLETE = 'SET_LOAN_DETAILS_COMPLETE';
export const SET_BANK_DETAILS_COMPLETE = 'SET_BANK_DETAILS_COMPLETE';
export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
export const SET_ONE_TIME_PAYMENT_DETAILS = 'SET_ONE_TIME_PAYMENT_DETAILS';
export const SET_TRANSACTION_HISTORY_DETAILS =
  'SET_TRANSACTION_HISTORY_DETAILS';
